export { default } from './SingleModalContainer.js';
